export type ModalSize = 'sm' | 'lg';
export enum ModalSizeValue {
  SM = 'sm',
  LG = 'lg',
}

export const ModalSizeValueMap = {
  [ModalSizeValue.SM]: 360,
  [ModalSizeValue.LG]: 552,
};
